<template>
    <div class="index-bar">
        <ul id="index-bar-ul" @touchstart.stop.prevent="indexBarStart($event)" @touchmove.stop.prevent="indexBarMove($event)" @touchend.stop.prevent="indexBarEnd($event)">
            <li v-for="(v, k, i) of character" :key="i">{{v}}</li>
        </ul>
    </div>
</template>
<script>
    export default {
        mounted() {
            this.li = document.getElementById("index-bar-ul").getElementsByTagName("li");
        },
        props: {
            // 字母索引
            character: {
                type: Array,
                default: function() {
                    return ["#","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
                }
            },
            // 字母索引对应的头部ID前缀
            prefix: {
                type: String,
                default: function() {
                    return "header";
                }
            }
        },
        data: function() {
            return {
                li: [],// 字母索引container
                clientHeight: 0,// li的高度
                boxClientTop: 0,// index-bar距离到屏幕顶部的距离
            }
        },
        methods: {
            indexBarStart(event) {
                var touch = event.touches[0];
                this.clientHeight = touch.target.offsetHeight;
                this.boxClientTop = touch.target.parentNode.offsetTop;
                this.jumpToElement(touch.clientY - this.boxClientTop);
            },
            /* eslint-disable */
            indexBarMove(event) {
                var touch = event.touches[0];
                this.jumpToElement(touch.clientY - this.boxClientTop);
            },
            indexBarEnd() {
                // do nothing
                return;
            },
            jumpToElement(offsetY) {
                let index = (offsetY <= 0) ? 0 : (parseInt(offsetY / this.clientHeight));
                const maxIndex = this.character.length - 1
                index = index > maxIndex ? maxIndex : index
                const selectedElement = document.querySelector('.index-bar-selected')
                selectedElement && selectedElement.classList.remove('index-bar-selected')
                document.getElementById('index-bar-ul').childNodes[index].classList.add('index-bar-selected')
                if (index > (this.character.length - 1)) {
                    index = this.character.length - 1;
                }
                var id = this.li[index].innerHTML.toLowerCase();
                if (id === "#") {
                    id = "医院";
                }
                var e = document.getElementById(this.prefix + id);
                if (e) {
                    e.scrollIntoView();
                }
            }
        }
    }
</script>
<style lang="scss">
    @import '../../static/sass/_variable.scss';
    .index-bar {
        z-index: 5;
        @include display-flex();
        @include justify-content(center);
        @include align-items(center);
        @include flex-direction(column);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        text-align: center;
        ul {
            pointer-events: initial;
        }
        li {
            @include flex(1);
            padding: 0 0.15rem;
            color: #333;
            font-size: 0.5rem!important;
            line-height: 160%!important;
        }
    }
    .index-bar-selected {
        background: $main-style-color;
        border-radius: 50%;
        color: white!important;
    }
</style>



// WEBPACK FOOTER //
// IndexBar.vue?18ef2393